import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { catchError, first, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { isEmpty } from 'lodash';

import { selectCompanyProfile } from 'projects/workspace/src/app/administration/store/selectors';
import { CompanyProfile } from 'projects/workspace/src/app/administration/models/company-profile.model';
import { AdministrationsApiService } from 'projects/workspace/src/app/administration/services/administrations-api.service';
import { AppState } from 'projects/workspace/src/app/store/state/app.state';
import { UpgradePlanModalComponent } from '../modules/modals/modals-common';
import { SbcPermissionEnum } from '../../../projects/workspace/src/app/administration/enums/sbc-permission.enum';

@Injectable({
  providedIn: 'root'
})
export class SbcPermissionGuard implements CanActivate {

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private readonly administrationsApiService: AdministrationsApiService,
    private readonly store: Store<AppState>
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    const sbcPermissionKey: SbcPermissionEnum = next.data['sbcPermissionKey'];

    return this.store.select(selectCompanyProfile).pipe(
      first(),
      switchMap((companyProfile: CompanyProfile) => {
        return isEmpty(companyProfile) ? this.administrationsApiService.getCompanyProfile() : of(companyProfile);
      }),
      catchError(() => {
        return of(false);
      }),
      switchMap((companyProfile: CompanyProfile) => {
        if (companyProfile.subscriptionManagement.subscriptionPermissions[sbcPermissionKey]) {
          return of(true);
        } else {
          this.dialog.open(UpgradePlanModalComponent, { data: {
            validationFeature: sbcPermissionKey,
            forwardUrl: state.url
          }});
          return of(false);
        }
      }),
    );
  }
}
